import type { AvatarStackProps } from './AvatarStack';
import { getCurrentUser } from '~/common/explicit-exports';
import { AvatarStack } from './AvatarStack';

export type BrandedAvatarStackProps = Omit<AvatarStackProps, 'brandColor'>;

export function BrandedAvatarStack(props: BrandedAvatarStackProps) {
  const {
    enterprise: { scheme_color: brandColor },
  } = getCurrentUser();

  return <AvatarStack brandColor={brandColor} {...props} />;
}
